var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInflammation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 51.5531C41.6258 51.5531 51.0502 42.1287 51.0502 30.5031C51.0502 18.8775 41.6258 9.45312 30.0002 9.45312C18.3746 9.45312 8.9502 18.8775 8.9502 30.5031C8.9502 42.1287 18.3746 51.5531 30.0002 51.5531Z",
    fill: "#F6DAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8701 47.87C31.5976 47.87 35.4301 44.0376 35.4301 39.31C35.4301 34.5824 31.5976 30.75 26.8701 30.75C22.1425 30.75 18.3101 34.5824 18.3101 39.31C18.3101 44.0376 22.1425 47.87 26.8701 47.87Z",
    fill: "url(#paint0_radial_10903_31991)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9699 36.2489C41.4493 36.2489 44.2699 33.4283 44.2699 29.9489C44.2699 26.4695 41.4493 23.6489 37.9699 23.6489C34.4905 23.6489 31.6699 26.4695 31.6699 29.9489C31.6699 33.4283 34.4905 36.2489 37.9699 36.2489Z",
    fill: "url(#paint1_radial_10903_31991)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7502 30.3303C29.688 30.3303 32.8802 27.1381 32.8802 23.2003C32.8802 19.2625 29.688 16.0703 25.7502 16.0703C21.8125 16.0703 18.6202 19.2625 18.6202 23.2003C18.6202 27.1381 21.8125 30.3303 25.7502 30.3303Z",
    fill: "url(#paint2_radial_10903_31991)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0197 32.708C39.5441 32.708 40.7798 31.4723 40.7798 29.948C40.7798 28.4237 39.5441 27.188 38.0197 27.188C36.4954 27.188 35.2598 28.4237 35.2598 29.948C35.2598 31.4723 36.4954 32.708 38.0197 32.708Z",
    fill: "url(#paint3_radial_10903_31991)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7501 26.4989C27.5726 26.4989 29.05 25.0215 29.05 23.1989C29.05 21.3764 27.5726 19.8989 25.7501 19.8989C23.9275 19.8989 22.4501 21.3764 22.4501 23.1989C22.4501 25.0215 23.9275 26.4989 25.7501 26.4989Z",
    fill: "url(#paint4_radial_10903_31991)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.92 43.2881C29.118 43.2881 30.8999 41.5062 30.8999 39.3081C30.8999 37.11 29.118 35.3281 26.92 35.3281C24.7219 35.3281 22.9399 37.11 22.9399 39.3081C22.9399 41.5062 24.7219 43.2881 26.92 43.2881Z",
    fill: "url(#paint5_radial_10903_31991)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10903_31991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8701 39.31) scale(8.56 8.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E39176",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E39176",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E39176",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E39176",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39176",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10903_31991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.9699 29.9489) scale(6.29999 6.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E39176",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E39176",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E39176",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E39176",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39176",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10903_31991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7502 23.2003) scale(7.13 7.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E39176",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E39176",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E39176",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39176",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10903_31991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0198 29.948) scale(2.75999 2.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39176",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10903_31991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7501 23.1989) scale(3.29999 3.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39176",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10903_31991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9199 39.3081) scale(3.98 3.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39176",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInflammation);
export default __webpack_public_path__ + "static/media/inflammation.dfd3e3fb6fa1064d8a1b777bab93a0a0.svg";
export { ForwardRef as ReactComponent };